import {del, get, post, put} from "../util/http.service";

export const apiGetFolders = () => ({
  queryKey: ["memos_folders"],
  queryFn: () => get("/api/memos/folders")
});

export const apiCreateFolder = () => ({
  mutationFn: data => post("/api/memos/folders", data)
});

export const apiUpdateFolder = id => ({
  mutationFn: data => put("/api/memos/folders/" + id, data)
});

export const apiDeleteFolder = () => ({
  mutationFn: data => del("/api/memos/folders/" + data.id)
});